module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2bc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rchapter01section01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01section01"
    }
  }, [_vm._v("Rampant Machismo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rchapter01section02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01section02"
    }
  }, [_vm._v("Come Up and See My Etchings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rchapter01section03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01section03"
    }
  }, [_vm._v("Sneakers and Deceivers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rchapter01section04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01section04"
    }
  }, [_vm._v("Headless Males Make Great Lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rchapter01section05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01section05"
    }
  }, [_vm._v("Trading Food for Sex")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rchapter01section06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01section06"
    }
  }, [_vm._v("Any Partner Will Do")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbca8086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 63
// module chunks = 0